export default "__VITE_ASSET__Dj0xBUKx__"